import React from "react";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Imgmenu from "./Imgmenu";
import "../../../css/menu.css";
import Menulist from "./Menulist";
import { useEffect } from "react";
import { getJson } from "./../../../apis/api";
import { toast } from "react-toastify";

const Menu = () => {
  useEffect(() => {
    async function fetchGeo() {
      try {
        const respDep = await getJson("listarDep");
        localStorage.setItem("listaDep", JSON.stringify(respDep.data));
        const respDis = await getJson("listarDis");
        localStorage.setItem("listaDis", JSON.stringify(respDis.data));
        const respCiu = await getJson("listarCiu");
        localStorage.setItem("listaCiu", JSON.stringify(respCiu.data));
        const respPais = await getJson("listarPais");
        localStorage.setItem("listaPais", JSON.stringify(respPais.data));
        const respAct = await getJson("listarAct");
        localStorage.setItem("listaActEco", JSON.stringify(respAct.data));
      } catch (error) {
        toast.error("Error en la obtencion de listados");
      }
    }
    fetchGeo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Paper sx={{ width: "17%", maxWidth: "100%" }} className="menu">
      <Imgmenu imagen="TF.png" />
      <Divider />
      <Menulist />
      <Divider />
      <Imgmenu imagen="logo_starsoft.png" />
    </Paper>
  );
};

export default Menu;
